import { IDocumentSchemaSettings, JsonValueSettings } from '@tap/data-providers';
import { ValueProps } from './values.types';
import { Typography } from '@mui/material';
import { AnyValue } from './AnyValue';

export type JsonValueProps = ValueProps<string | object, JsonValueSettings> & {
    schemaDict?: { [key: string]: IDocumentSchemaSettings },
};

export const JsonValue = ({ value, settings = {}, schemaDict = {} }: JsonValueProps) => {

    const { emptyText = '-', schemaName } = settings;

    if (schemaName && schemaName in schemaDict) {
        return <>TODO</>
    }

    if (!value) {
        return (
            <Typography>{emptyText}</Typography>
        );
    }

    return (
        <AnyValue value={value} />
    );
}